module.exports = __webpack_public_path__ + "685d69c7dbca6f7f83e24c3837cefe46.pdf";